var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.754 5.5603C24.7703 5.79539 24.7703 6.03047 24.7703 6.26773C24.7703 13.4969 19.2668 21.8344 9.2036 21.8344V21.8301C6.23088 21.8344 3.31992 20.9829 0.817383 19.3773C1.24964 19.4293 1.68406 19.4553 2.11957 19.4564C4.58311 19.4586 6.97623 18.632 8.91434 17.1099C6.57322 17.0655 4.52027 15.539 3.8031 13.3106C4.62319 13.4688 5.46821 13.4363 6.27314 13.2163C3.72076 12.7007 1.88448 10.4581 1.88448 7.85375C1.88448 7.82992 1.88448 7.80717 1.88448 7.78442C2.64499 8.20801 3.49651 8.4431 4.36752 8.4691C1.96357 6.86249 1.22256 3.66444 2.67425 1.16407C5.45196 4.58204 9.55027 6.6599 13.9498 6.87982C13.5088 4.97962 14.1112 2.98843 15.5325 1.65266C17.7361 -0.418709 21.2017 -0.312541 23.2731 1.88991C24.4983 1.64832 25.6727 1.19873 26.7474 0.561723C26.339 1.82816 25.4842 2.90393 24.3423 3.58752C25.4268 3.45968 26.4863 3.16935 27.4841 2.72626C26.7495 3.82694 25.8244 4.78571 24.754 5.5603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/TwitterWhite.42b6b5cb4b0d8ab90ac7085ee8c0c833.svg";
export { ForwardRef as ReactComponent };